<!-- Header da Pagina -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-truck"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<!-- Grid de Cards -->
<div class="cards-container">
  <!-- Coluna Esquerda -->
  <div class="column-left">
    <!-- Card Identificacao -->
    <div class="form-card">
      <div class="card-header">
        <div class="card-header-icon">
          <i class="pi pi-id-card"></i>
        </div>
        <span class="card-header-title">{{ texts.identificacao }}</span>
      </div>
      <div class="card-content">
        <div class="form-grid">
          <div class="form-field half">
            <label class="form-label">{{ labels.tipoPessoa }} <span class="required">*</span></label>
            <p-dropdown id="tipoPessoa" [class.error-field]="isFormSubmitted && !form.tipoPessoa" [options]="tipoPessoaOptions"
              [(ngModel)]="form.tipoPessoa" optionLabel="label" styleClass="w-full"
              [placeholder]="placeholders.tipoPessoa" appendTo="body"
              (onChange)="onTipoPessoaChange()"></p-dropdown>
          </div>
          <div class="form-field half" *ngIf="form.tipoPessoa?.value === 'FISICA'">
            <label class="form-label">{{ labels.ci }}</label>
            <input type="text" pInputText [(ngModel)]="form.ci"
              [placeholder]="placeholders.ci" class="w-full"
              (input)="onCiInput($event)" />
          </div>
          <div class="form-field half" *ngIf="form.tipoPessoa?.value === 'JURIDICA'">
            <app-ruc-busca
              #rucBuscaRef
              [showLabel]="true"
              [label]="labels.ruc"
              [placeholder]="placeholders.ruc"
              (pessoaConfirmada)="onRucPessoaConfirmada($event)"
              (pessoaVinculada)="onRucPessoaVinculada($event)"
              (rucValueChange)="form.ruc = $event"
              (rucLimpo)="onRucLimpo()">
            </app-ruc-busca>
          </div>
          <div class="form-field full">
            <label class="form-label">{{ labels.nome }} <span class="required">*</span></label>
            <input [class.error-field]="isFormSubmitted && !form.nome" type="text" pInputText [(ngModel)]="form.nome"
              [placeholder]="placeholders.nome" class="w-full" />
          </div>
          <div class="form-field full">
            <label class="form-label">{{ labels.nomeFantasia }}</label>
            <input type="text" pInputText [(ngModel)]="form.fantasia"
              [ngClass]="{'input-field-disabled': form.tipoPessoa?.value != 'JURIDICA'}"
              [disabled]="form.tipoPessoa?.value != 'JURIDICA'"
              [placeholder]="placeholders.nomeFantasia" class="w-full" />
          </div>
          <div class="form-field half">
            <label class="form-label">{{ labels.tipoNaturezaFiscal }} <span class="required">*</span></label>
            <p-dropdown id="tipoNaturezaFiscal" [class.error-field]="isFormSubmitted && !form.tipoNaturezaFiscal"
              [options]="tipoNaturezaFiscalOptions" [(ngModel)]="form.tipoNaturezaFiscal" optionLabel="label" styleClass="w-full"
              [placeholder]="placeholders.tipoNaturezaFiscal" appendTo="body"></p-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Coluna Direita -->
  <div class="column-right">
    <!-- Card Contato -->
    <div class="form-card">
      <div class="card-header">
        <div class="card-header-icon contact-icon">
          <i class="pi pi-phone"></i>
        </div>
        <span class="card-header-title">{{ texts.contato }}</span>
      </div>
      <div class="card-content">
        <div class="form-grid">
          <div class="form-field full">
            <app-phone-input
              [(telefone)]="form.telefone"
              [(ddi)]="paisSelecionado"
              [label]="labels.ddi + ' / ' + labels.telefone"
              [placeholder]="placeholders.telefone">
            </app-phone-input>
          </div>
          <div class="form-field full">
            <label class="form-label">{{ labels.email }}</label>
            <input type="email" pInputText [(ngModel)]="form.email"
              [placeholder]="placeholders.email" class="w-full" />
          </div>
        </div>
      </div>
    </div>

    <!-- Card Endereco -->
    <div class="form-card">
      <div class="card-header">
        <div class="card-header-icon address-icon">
          <i class="pi pi-map-marker"></i>
        </div>
        <span class="card-header-title">{{ texts.endereco }}</span>
      </div>
      <div class="card-content">
        <div class="form-grid">
          <div class="form-field half">
            <label class="form-label">{{ labels.cidade }}</label>
            <p-dropdown id="selecionarCidade" [options]="cidadeList" [(ngModel)]="form.cidade" optionLabel="label"
              [placeholder]="placeholders.cidade" [filter]="true" filterBy="label"
              [showClear]="true" (onChange)="onSelecionarCidade($event)" styleClass="w-full" appendTo="body"
              panelStyleClass="ddi-dropdown-panel-erp" scrollHeight="340px"></p-dropdown>
          </div>
          <div class="form-field half">
            <label class="form-label">{{ labels.estado }}</label>
            <input type="text" pInputText class="w-full input-field-disabled" [disabled]="true"
              [(ngModel)]="estadoCidade" />
          </div>
          <div class="form-field two-thirds">
            <label class="form-label">{{ labels.endereco }}</label>
            <input type="text" pInputText [(ngModel)]="form.endereco"
              [placeholder]="placeholders.endereco" class="w-full" />
          </div>
          <div class="form-field third">
            <label class="form-label">{{ labels.numero }}</label>
            <input type="text" pInputText [(ngModel)]="form.numero"
              [placeholder]="placeholders.numero" class="w-full" />
          </div>
        </div>
      </div>
    </div>

    <!-- Card Dados Pessoais -->
    <div class="form-card">
      <div class="card-header">
        <div class="card-header-icon personal-icon">
          <i class="pi pi-user"></i>
        </div>
        <span class="card-header-title">{{ texts.dadosPessoais }}</span>
      </div>
      <div class="card-content">
        <div class="form-grid">
          <div class="form-field half">
            <label class="form-label">{{ labels.dataNascimento }}</label>
            <input type="date" pInputText [(ngModel)]="form.dataNascimento"
              max="9999-12-31" min="1900-01-01"
              (input)="onDateInput($event)"
              class="w-full" />
          </div>
          <div class="form-field half">
            <label class="form-label">{{ labels.sexo }} <span class="required">*</span></label>
            <p-dropdown id="sexo" [class.error-field]="isFormSubmitted && !form.sexo" [options]="sexoOptions"
              [(ngModel)]="form.sexo" optionLabel="label" styleClass="w-full"
              [placeholder]="placeholders.sexo" appendTo="body"></p-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Botoes de Acao -->
<div class="actions-container">
  <button pButton [label]="botoes.voltar" (click)="navigateListaDeFornecedores()"
    severity="secondary" icon="pi pi-arrow-left" class="btn-secondary"></button>
  <button pButton [label]="botoes.enviar" icon="pi pi-check"
    (click)="submit()" [disabled]="submitting" [loading]="submitting" class="btn-primary"></button>
</div>

<!-- Dialog de Pessoa Ja Cadastrada -->
<p-dialog
  [(visible)]="pessoaJaCadastradaDialogVisible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '30rem' }">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-info-circle" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.identificacao }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ pessoaJaCadastradaMensagem }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="botoes.voltar" class="p-button-secondary"
      (click)="pessoaJaCadastradaDialogVisible = false"></button>
    <button pButton label="Editar" icon="pi pi-pencil"
      (click)="editarPessoaJaCadastrada()"></button>
  </ng-template>
</p-dialog>

<p-toast />
